angular.module('picmonicng').directive('gaSend', [
  function () {
    return {
      restrict: 'A',
      scope: {
        gaSend: '=',
      },
      link: function (scope, element, attrs) {
        element.bind('click', function (event) {
          send_ga(scope.gaSend[0], scope.gaSend[1], scope.gaSend[2]);
        });
      },
    };
  },
]);
